import { Order } from '@/models/order.model';
import httpClient from './http-client';

function get(orderId: string, receipt?: string) {
  return httpClient.get(`orders/${orderId}?receipt=${receipt}`);
}

function list(orderStatus?: string, pickupDate?: Date) {
  let url = orderStatus ? `orders?orderStatus=${orderStatus}` : 'orders';
  if (pickupDate) {
    url += `&pickupDate=${pickupDate}`;
  }
  return httpClient.get(url);
}

function update(id: string, order: any, pin: string) {
  return httpClient.put(`orders/${id}`, { ...order, pin });
}

function remove(id: string) {
  return httpClient.delete(`orders/${id}`);
}

function updatePackingStatus(
  id: string,
  itemId: string,
  index: number,
  isReady: boolean
) {
  return httpClient.put(`orders/${id}/packing`, { itemId, index, isReady });
}

function post(order: Order) {
  return httpClient.post('orders', order);
}

export const ordersClient = {
  get,
  list,
  update,
  post,
  updatePackingStatus,
  remove,
};
